export const FEEDBACK_PROGRESS_CAPS = Object.freeze({
  10: 24,
  25: 39,
  40: 54,
  55: 74,
  75: 89,
  90: 90,
});

export function feedbackProgressCap(serverProgress) {
  const progress = Number(serverProgress);
  if (!Number.isFinite(progress) || progress >= 100) return 90;

  const milestone = Object.keys(FEEDBACK_PROGRESS_CAPS)
    .map(Number)
    .filter((value) => value <= progress)
    .sort((a, b) => b - a)[0];

  return milestone == null ? 10 : FEEDBACK_PROGRESS_CAPS[milestone];
}

export function advanceFeedbackProgress(displayedProgress, serverProgress) {
  const displayed = Number.isFinite(Number(displayedProgress))
    ? Number(displayedProgress)
    : 10;
  const server = Number.isFinite(Number(serverProgress))
    ? Number(serverProgress)
    : 10;
  const cap = feedbackProgressCap(server);
  return Math.min(cap, Math.max(displayed, server) + 1);
}
